export enum EContractType {
  /** 签约中 */
  SIGNING = 0,
  /** 签约申请中 */
  APPLYING = 1,
  /** 续约申请中 */
  RENEWING = 3,
  /** 解约申请中 */
  CANCELING = 5,
}

export enum EContractStatus {
  /** 超时未处理 */
  Outdated = -4,
  /** 已失效 */
  Expired = -3,
  /** 已撤回 */
  Revoked = -2,
  /** 已拒绝 */
  Rejected = -1,
  /** 未处理 */
  Unprocessed = 0,
  /** 已同意 */
  Accepted = 1,
}

export enum EDurationID {
  ThreeYears = 4,
  FiveYears = 5,
}

export enum EInviteType {
  /** 邀请签约 */
  Join = 2,
  /** 邀请续约 */
  Renew = 4,
}
